import { useSelector } from 'react-redux';
import Routes from '../../../../../constants/routes';
import useIsMobile from '../../../../../hooks/use-is-mobile';
import schoolAccount from '../../../../../utils/school-account';
import session from '../../../../../utils/session';

type UseCardVisibilityReturn = {
    isMobile: boolean;
    isTabletOrMobile: boolean;
    shouldShowFolder: boolean;
    shouldShowAddToCart: boolean;
};

const useCardVisibility = (): UseCardVisibilityReturn => {
    const user = useSelector((state: RootState) => state.main.user);

    const isMobile = useIsMobile(767);
    const isTabletOrMobile = useIsMobile();

    const isSchoolWishlist = window.location.pathname === Routes.SCHOOL_WISHLIST.path;
    const shouldShowFolder = !isSchoolWishlist && session.isLoggedIn() && !isMobile;
    const shouldShowAddToCart = !(isSchoolWishlist && !schoolAccount.isAdmin(user));

    return { isMobile, isTabletOrMobile, shouldShowFolder, shouldShowAddToCart };
};

export default useCardVisibility;
